import React from "react";
import { useSelector } from "react-redux";

import {
  selectRevenueKpis,
  selectRevenueFlow,
} from "../../../../slices/report/selectors";

import RevenueKpiCards from "../components/RevenueKpiCards";
import RevenueFlowChart from "../components/RevenueFlowChart";

const RevenueView = () => {
  const revenueKpis = useSelector(selectRevenueKpis);
  const revenueFlow = useSelector(selectRevenueFlow);

  return (
    <>
      <RevenueKpiCards
        totalListing={revenueKpis?.total_listing}
        totalSold={revenueKpis?.total_sold}
        totalListingSold={revenueKpis?.total_listing_sold}
        totalCollected={revenueKpis?.total_collected}
        remainingToSell={revenueKpis?.remaining_to_sell}
        soldUnits={revenueKpis?.sold_units || 0}
        totalUnits={revenueKpis?.total_units || 0}
      />

      <RevenueFlowChart flow={revenueFlow} />
    </>
  );
};

export default RevenueView;
